import { permissions } from '@mpk/shared/domain';

enum TransactionManagementOrganizationSettingsPermissionsEnum {
  None = 0,

  /**
   * Manage the organization settings for the transaction management.
   */
  ManageSettings = 1,
}

export const TransactionManagementOrganizationSettingsPermissions = permissions(
  TransactionManagementOrganizationSettingsPermissionsEnum,
  {
    featureId: 'ModuleSettings',
  },
);
